import { RefreshCwIcon } from "lucide-react";
import { Button, ButtonProps } from "./button";

type Props = ButtonProps & {
  loading?: boolean;
};

export const LoadingButton: React.FC<Props> = ({
  loading,
  children,
  ...props
}) => {
  return (
    <Button disabled={loading} {...props}>
      {loading && <RefreshCwIcon className="mr-2 size-4 animate-spin" />}
      {children}
    </Button>
  );
};
